import React from 'react';
import { Select, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

/**
 * Shared 3-state view selector (Auto / Table / Cards) used by every list that can
 * render either as a table or as cards. "Auto" lets the responsive hook decide based
 * on whether the table fits; "Table"/"Cards" are explicit user overrides.
 */
const ViewModeSelect = ({ value, onChange, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Space>
      <Text type="secondary">{t('common.view')}</Text>
      <Select
        value={value}
        onChange={(nextView) => onChange(nextView)}
        style={{ width: 150 }}
        aria-label={t('common.view')}
        options={[
          { value: 'auto', label: t('common.viewAuto') },
          { value: 'table', label: t('common.viewTable') },
          { value: 'cards', label: t('common.viewCards') },
        ]}
        {...rest}
      />
    </Space>
  );
};

export default ViewModeSelect;
